import { render, staticRenderFns } from "./passwordChange.vue?vue&type=template&id=b418319a&scoped=true&"
import script from "./passwordChange.vue?vue&type=script&lang=js&"
export * from "./passwordChange.vue?vue&type=script&lang=js&"
import style0 from "./passwordChange.vue?vue&type=style&index=0&id=b418319a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b418319a",
  null
  
)

export default component.exports